import BaseService from '@/network/base-service'

class RelatorioMedicoService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/documentossolicitacoes`)
  }
  solicitarRelatorio (params) {
    return this.post(`solicitar`, { ...params })
  }
}

export default new RelatorioMedicoService()
